<template>
  <div
    class="loading-widget"
    :style="{ 'grid-template-columns': calcGrid(colums) }"
  >
    <div class="loading-item pulse" v-for="(item, index) in items" :key="index">
      <div class="loading-image"></div>
      <div class="loading-content">
        <div class="loading-title"></div>
        <div class="loading-price"></div>
      </div>
      <div class="loading-shop"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_loading",
  props: {
    items: {
      type: Number,
      default: 5,
    },
    colums: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    calcGrid(colums) {
      let item_size = 100 / colums - 2;
      // eslint-disable-next-line no-unused-vars
      let style = "";
      for (let i = 0; i < colums; i++) {
        style += item_size.toString() + "% ";
      }
      console.log(style);
      return style;
    },
  },
};
</script>
<style lang="scss" scoped>
.pulse {
  box-shadow: 0px 0px 1px 1px #0000001a;
  animation: pulse-animation 1s infinite;
}

@keyframes babo {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 7px rgba(0, 0, 0, 0);
  }
}

.bubble {
  animation: bubble-animation 2s infinite;
  transition: 500 ease-in-out;
}

@keyframes bubble-animation {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
.loading-widget {
  display: grid;
  grid-gap: 15px;
  justify-content: space-between;
  width: 100%;
  margin: 20px 0px;
  .loading-item {
    border: 1px solid rgb(226, 226, 226);
    background: rgb(243, 243, 243);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    padding: 10px;
    .loading-image {
      height: 200px;
      width: 100%;
      background: #fff;
      border-radius: 5px;
    }
    .loading-content {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .loading-title {
        width: 70%;
        height: 15px;
        background: #fff;
      }
      .loading-price {
        width: 40%;
        height: 15px;
        background: #fff;
        margin-top: 10px;
      }
    }
    .loading-shop {
      margin-top: 10px;
      height: 65px;
      width: 100%;
      background: #fff;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      -ms-border-radius: 5px;
      -o-border-radius: 5px;
    }
  }
}
</style>
